class SalesReportSubscriberService extends AbstractSubscriberService
	@register()
	@inject 'BACKEND_SUBSCRIBER_PERIOD'

	hasShop: ->
		return true

	hasRegister: ->
		return false

	getPeriods: ->
		return [
			@BACKEND_SUBSCRIBER_PERIOD.WEEKLY,
			@BACKEND_SUBSCRIBER_PERIOD.MONTHLY,
		]
